import React from "react";
import Footer from "../../Public/Footer/Footer";

function ContentsWrapper(props) {
  return (
    <div className="main-panel">
      {props.header}

      <div className="content ">
        {props.children}

        <Footer />
      </div>
    </div>
  );
}

export default ContentsWrapper;
